import React from 'react';

import { t } from '~/helpers';

import * as S from './styles';

function SemDados() {
  return <S.Wrapper>{t('s.dashboard.visaogeral.semdados')}</S.Wrapper>;
}

export default SemDados;
